import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Switch,
  Text,
  Spinner,
} from "@chakra-ui/react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useMemo, useState } from "react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import SearchTable3 from "components/Tables/SearchTable3";
import { IoIosArrowDown } from "react-icons/io";
import { clientsApiAction } from "stores/redux/apiSlices/clientApi/clientApiSlice";
import { ClientColumn } from "variables/columnsData";

function CustomerList({ handleAddClient, handleEdit, handleDelete }) {
  const [isActive, setIsActive] = useState(undefined);

  const filters = useMemo(() => {
    const base = { role: "CLIENT", limit: 100 };

    if (isActive === true) base.isActive = true;
    else if (isActive === false) base.isActive = false;

    return base;
  }, [isActive]);

const { data, error, isLoading: apiLoading, refetch } = clientsApiAction.getClientListApi(
  filters,
  {
    refetchOnMountOrArgChange: true,
  }
);

// Directly use apiLoading
const isLoading = apiLoading;

useEffect(() => {
  refetch();
}, [refetch, isActive]);

const userListData = data?.data?.users || [];


  return (
    <Flex direction="column" pt={{ sm: "125px", md: "75px" }}>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        w="100%"
        mb="24px"
      >
        <Button
          mt={0}
          bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          _hover={{
            bg: "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
          }}
          _disabled={{
            _hover: {
              bg: "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
            },
          }}
          color="#fff"
          minW="125px"
          h="35px"
          fontSize="xs"
          fontWeight="bold"
          mb={{ sm: "12px", md: "0px" }}
          onClick={handleAddClient}
        >
          ΠΡΟΣΘΗΚΗ ΠΕΛΑΤΗ
        </Button>
        <Stack direction="row" spacing="10px">
          <Menu zIndex={100}>
            <MenuButton
              as={Button}
              rightIcon={<IoIosArrowDown />}
              color="gray.700"
              w="125px"
              h="35px"
              bg="#fff"
              fontSize="xs"
            >
              ΦΙΛΤΡΑ
            </MenuButton>
            <MenuList>
              <MenuItem
                closeOnSelect={false}
                onClick={() => {
                  setIsActive((prev) => (prev === true ? undefined : true));
                }}
              >
                <Flex justify="space-between" align="center" w="100%">
                  <Text color="gray.500">Ενεργό</Text>
                  <Switch
                    size="sm"
                    isChecked={isActive === true}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() =>
                      setIsActive((prev) => (prev === true ? undefined : true))
                    }
                  />
                </Flex>
              </MenuItem>

              <MenuItem
                closeOnSelect={false}
                onClick={() => {
                  setIsActive((prev) => (prev === false ? undefined : false));
                }}
              >
                <Flex justify="space-between" align="center" w="100%">
                  <Text color="gray.500">Ανενεργό</Text>
                  <Switch
                    size="sm"
                    isChecked={isActive === false}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() =>
                      setIsActive((prev) =>
                        prev === false ? undefined : false
                      )
                    }
                  />
                </Flex>
              </MenuItem>

              <MenuDivider />
              <MenuItem color="red.300" onClick={() => setIsActive(undefined)}>
                Εκκαθάριση
              </MenuItem>
            </MenuList>
          </Menu>

          <Button
            variant="no-hover"
            bg="#fff"
            w="125px"
            h="35px"
            color="gray.700"
            fontSize="xs"
            fontWeight="bold"
            onClick={() => {
              if (!userListData || userListData.length === 0) {
                console.warn("No data available to export.");
                return;
              }

              const worksheet = XLSX.utils.json_to_sheet(userListData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

              const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
              });

              const blob = new Blob([excelBuffer], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              const currentDate = new Date().toISOString().split("T")[0];
              saveAs(blob, `userListData_${currentDate}.xlsx`);
            }}
          >
            ΕΞΑΓΩΓΗ
          </Button>
        </Stack>
      </Flex>

      <Card px="0px">
        <CardBody>
          {isLoading ? (
            <Flex
              justify="center"
              align="center"
              direction="column"
              minH="300px"
              w="100%"
            >
              <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
              <Text mt={4} fontSize="md" color="gray.600">
                Loading customers...
              </Text>
            </Flex>
          ) : (
            <SearchTable3
              tableData={userListData}
              onEdit={handleEdit}
              onDelete={handleDelete}
              columnsData={ClientColumn}
            />
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}

export default CustomerList;